import { render } from "./RenderView.vue?vue&type=template&id=b12ca4f2"
import script from "./RenderView.vue?vue&type=script&lang=js"
export * from "./RenderView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\glenside-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__